import { Outlet, useParams } from 'react-router-dom';
import { AgreementHeader } from './components/agreement-header.component';
import { AgreementProgressBar } from './components/agreement-progress-bar.component';
import { PageListLayout } from '../../../components/layout/page-list-layout';
import { PermissionKeys } from '@client/api';
import { HasAgreementPermission } from '../../../components/permission/has-agreement-permission';
import { NoPackageAccessPage } from '../../../components/no-access-modal';

export function AgreementLayout() {
  const { id } = useParams<{ id: string }>();

  return (
    <HasAgreementPermission id={id} permissions={[PermissionKeys.Agreement.View]} fallback={<NoPackageAccessPage />}>
      <PageListLayout>
        <AgreementHeader />
        <AgreementProgressBar />
        <Outlet />
      </PageListLayout>
    </HasAgreementPermission>
  );
}
